export enum TestsStatusFilter {
    // These values are used by the API
    All = 'all',
    AllPass = 'all_pass',
    HasFailing = 'has_failing',
    HasUnrun = 'has_unrun',
};